import {
  intersectionWatcher,
  delayOffset,
  shouldAnimate,
} from "@/lib/animation";
import { qsa } from "@fluorescent/dom";

const selectors = {
  slides: ".slideshow__slide",
  animateBackground: ".slideshow__content-inner-container--has-background",
  sectionBlockItems: ".slideshow__content-inner-container > *",
};

export default node => {
  if (!shouldAnimate(node)) return;

  const slides = qsa(selectors.slides, node);

  slides.forEach(slide => {
    // Add the animation delay offset variables
    delayOffset(
      slide,
      [selectors.animateBackground, selectors.sectionBlockItems],
      3
    );
  });

  const observer = intersectionWatcher(node);

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
